const instructions = {
  access: 'Permita acesso à câmera',
  network: 'Esteja conectado à rede',
  point: 'Aponte a câmera para um QRCode do GEEQUIP',
};

export default instructions;
